






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    InsLogo: () => import('@/components/base/InsLogo.vue'),
    InsLangSwitch: () =>
      import('@/components/business/header/InsLangSwitch.vue'),
    InsMenu: () => import('@/components/business/header/InsMenu.vue')
  }
})
export default class InsHeader extends Vue {
  private menuShow: boolean = false;

  getMenu () {
    this.$Api.promotion
      .getMenu()
      .then(result => {
        this.$store.dispatch('setHeaderMenus', result.ReturnValue.HeaderMenus);
        this.$store.dispatch('setFooterMenus', result.ReturnValue.FooterMenus);
      })
      .catch(error => {
        console.log(error);
      });
  }

  showSlideMenu () {
    this.menuShow = !this.menuShow;
    this.$store.dispatch('isShowMenu', this.menuShow);
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  mounted () {
    this.getMenu();
  }
}
